export const isCordova = window.location.host === "cordova.vekilet.com";
export const isAndroid = window.navigator.userAgent
  .toLowerCase()
  .includes("vekilet android");
export const isIOS = window.navigator.userAgent
  .toLowerCase()
  .includes("vekilet ios");
